export const ATOL_ONLINE_NAME = 'АТОЛ\u00A0Онлайн';
